"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="container py-32 text-center">
      <h1 className="text-4xl font-bold text-primary-dark/60">
        Something went wrong
      </h1>
      <button
        className="mt-6 rounded bg-[#f26e21] px-6 py-2 text-white"
        onClick={() => reset()}
      >
        Try again
      </button>
    </div>
  );
}
